import React, { FunctionComponent } from 'react';

import styled, { useTheme } from 'styled-components';

import { ReleaseStore } from '@common/types/release/release-store';

import Box from '@components/layout/box';
import Typography from '@components/basics/typography';
import Grid from '@components/basics/grid';
import { Translate } from 'react-localize-redux';

interface StoreDropdownListProps {
  className?: string;
  stores: ReleaseStore[];
  activeStore: ReleaseStore[];
  noBorderBottom?: boolean;
}

const StoreDropdownList: FunctionComponent<StoreDropdownListProps> = ({
  className,
  stores,
  activeStore,
  noBorderBottom,
}) => {
  const theme = useTheme();
  return (
    <Grid className={className || ''} gap={3}>
      <Box noBorderBottom>
        <Grid gap={5}>
          <Typography type="big-title" customFont="medium">
            <Translate id="CATALOG.TAKEDOWN.TAKEDOWN.STORE_LIST.FROM" />
          </Typography>
          <Typography color={theme.colors.tertiary} type="small">
            <Translate
              id="CATALOG.TAKEDOWN.TAKEDOWN.STORE_LIST.STORES"
              data={{ amount: activeStore.length }}
            />
          </Typography>
        </Grid>
        {activeStore.length ? (
          <Typography className="stores">
            {activeStore
              .reduce((acc, item) => acc + `${item.name}, `, '')
              .slice(0, -1)}
          </Typography>
        ) : null}
      </Box>
      <Box noBorderTop noBorderBottom={noBorderBottom}>
        <Grid gap={5}>
          <Typography type="big-title" customFont="medium">
            <Translate id="CATALOG.TAKEDOWN.TAKEDOWN.STORE_LIST.REMAINS" />
          </Typography>
          <Typography color={theme.colors.tertiary} type="small">
            <Translate
              id="CATALOG.TAKEDOWN.TAKEDOWN.STORE_LIST.STORES"
              data={{
                amount: stores.filter((item) => !activeStore.includes(item))
                  .length,
              }}
            />
          </Typography>
        </Grid>
        {stores.filter((item) => !activeStore.includes(item)).length ? (
          <Typography className="stores">
            {stores
              .filter((item) => !activeStore.includes(item))
              .reduce((acc, item) => acc + `${item.name}, `, '')
              .slice(0, -1)}
          </Typography>
        ) : null}
      </Box>
    </Grid>
  );
};

export default styled(StoreDropdownList)`
  .stores {
    margin-top: 20px;
  }
`;
